import { createFileRoute } from "@tanstack/react-router";
import StoreLocations from "@/features/tradein/pages/store-locations/StoreLocations";

export const Route = createFileRoute("/$locale/$partner/_trade-in/store-locations")({
	component: StoreLocations,
});
